var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c("bootstrap-table", {
            ref: "table",
            attrs: {
              columns: _vm.columns,
              data: _vm.data,
              options: _vm.options,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }